var _rect, _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOnGoingOrder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M10.343 21.805H.891v-20h18V8.26h-1.492V3.292H2.382v17.026h7.96Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0e2240"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.251 7.863H4.911v-1.5h10.34ZM8.872 12.642H4.911v-1.5h3.961ZM8.872 17.421H4.911v-1.5h3.961Z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m14.789 18.317 3.835-1.483v-3.322h-1.652v2.3l-2.715 1.073Z"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#12223e",
  strokeWidth: 1.5,
  transform: "translate(10.875 9.9)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.091,
  cy: 6.091,
  r: 6.091,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.091,
  cy: 6.091,
  r: 5.341
}))));
export { SvgOnGoingOrder as ReactComponent };
export default "/_next/static/images/on_going_order.svg";